import TodayRoundedIcon from '@mui/icons-material/TodayRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';
import PendingActionsRoundedIcon from '@mui/icons-material/PendingActionsRounded';
import UpcomingRoundedIcon from '@mui/icons-material/UpcomingRounded';
import PauseCircleOutlineRoundedIcon from '@mui/icons-material/PauseCircleOutlineRounded';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';

// สไตล์ pill-tab เดียวกับหน้า /finance/expenses (ExpensesList.js) — ไอคอน/gradient ใช้ชุดสีเดียวกันกับ
// tab วันนี้/ค้างดำเนินการ/อนาคต ของหน้านั้นเป๊ะ เพื่อความสม่ำเสมอของ UI ทั้งระบบ
export const TABS = [
  {
    key: 'today',
    label: 'วันนี้',
    icon: TodayRoundedIcon,
    gradient: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
  },
  {
    key: 'backlog',
    label: 'ค้าง',
    icon: PendingActionsRoundedIcon,
    gradient: 'linear-gradient(135deg, #f59e0b 0%, #f97316 100%)',
  },
  {
    key: 'future',
    label: 'อนาคต',
    icon: UpcomingRoundedIcon,
    gradient: 'linear-gradient(135deg, #06b6d4 0%, #3b82f6 100%)',
  },
  {
    key: 'hold',
    label: 'รอก่อน',
    icon: PauseCircleOutlineRoundedIcon,
    gradient: 'linear-gradient(135deg, #64748b 0%, #94a3b8 100%)',
  },
  {
    key: 'history',
    label: 'ประวัติ',
    icon: HistoryRoundedIcon,
    gradient: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)',
  },
];

// sub-tabs ของแท็บ "วันนี้" — mirror sub-tab ของ ExpensesTabToday.js (/finance/expenses)
//  approved = พฤติกรรมเดิมของแท็บวันนี้ (Expense.date = วันนี้, ทุกสถานะ)
//  urgent   = is_urgent:true (urgentQueue) — ยังไม่จบเอาหมด + SUCCESS เฉพาะที่จ่ายวันนี้
//  due      = อนุมัติ (จุดที่ช้าสุด) เมื่อวาน → ครบกำหนดจ่ายวันนี้ (statuses APPROVE/PREPARE/SUCCESS)
export const TODAY_SUBTABS = [
  {
    key: 'approved',
    label: 'อนุมัติวันนี้',
    icon: CheckCircleRoundedIcon,
    gradient: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
  },
  {
    key: 'urgent',
    label: 'ด่วน',
    icon: BoltRoundedIcon,
    gradient: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
  },
  {
    key: 'due',
    label: 'จ่ายเงินวันนี้',
    icon: PaymentsRoundedIcon,
    gradient: 'linear-gradient(135deg, #10b981 0%, #14b8a6 100%)',
  },
];

// 12 คอลัมน์: checkbox / ลำดับ / รหัสรายการเบิก / สถานะเบิก / วันที่(สร้าง/อนุมัติ/จ่ายเงิน) /
// งาน-รหัสงบ / ยอดเบิก / บัญชีผู้รับเงิน / รายละเอียด / อนุมัติ / อนุมัติโดย-เวลา / หมายเหตุการอนุมัติ
// — เดิมเป็น % รวม 100% เต็มความกว้าง container พอดี (ไม่มี scroll แนวนอนเลย) แต่บางคอลัมน์ (ยอดเบิก,
// ปุ่มอนุมัติ 3 ปุ่ม) แคบเกินไปจนค่า/ปุ่มล้นออกนอกคอลัมน์ตัวเอง — เปลี่ยนเป็นหน่วย px ตายตัวแทน (กว้าง
// พอต่อคอลัมน์จริง) ให้ตารางกว้างกว่า container ได้แล้วปล่อยให้ scroll แนวนอนแทน (ดู overflowX ที่
// TableContainer ใน PaymentApproval.js + useDragScroll ให้ลาก mouse scroll ได้ด้วย) TABLE_MIN_WIDTH
// ต้องเท่าผลรวม COL_WIDTHS เสมอ (แก้คู่กัน)
export const COL_WIDTHS = [
  '44px',
  '80px',
  '130px',
  '140px',
  '140px',
  '170px',
  '110px',
  '170px',
  '280px',
  '200px',
  '180px',
  '140px',
];
export const TABLE_MIN_WIDTH = 1784;

// เดิมล็อกความสูงหน้าไว้ 100vh ให้ตารางใน scroll เอง — เปลี่ยนเป็น scroll ทั้งหน้า (window) แล้ว
// ค่านี้เลิกใช้ (คงไว้กัน import พังถ้ามีที่อื่นอ้าง)
export const PAGE_HEIGHT = 'auto';
